import { useTranslation } from "react-i18next";

const ChatTopBar = ({
    activeChat,
    renamingChatId,
    renameValue,
    setRenameValue,
    onRenameStart,
    onRenameCommit,
    customerDisplay,
    chips,
    onChipClick,
}) => {
    const { t } = useTranslation();
    return (
        <div className="border-b border-white/70 bg-white/60 backdrop-blur-xl px-3 py-4 shadow-[0_18px_44px_rgba(79,70,229,0.14)]">
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-2">
                <div>
                    <div className="flex items-center gap-3">
                        {renamingChatId === activeChat?.id ? (
                            <input
                                value={renameValue}
                                onChange={(event) => setRenameValue(event.target.value)}
                                onBlur={onRenameCommit}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        event.preventDefault();
                                        onRenameCommit();
                                    }
                                }}
                                className="rounded-[12px] border border-white/60 bg-white/70 backdrop-blur px-3 py-2 text-sm
                                shadow-[0_12px_30px_rgba(15,23,42,0.10)] focus:outline-none"
                            />
                        ) : (
                            <button
                                type="button"
                                className="text-sm font-semibold text-slate-900 hover:underline"
                                onClick={onRenameStart}
                            >
                                {activeChat?.title || t('aura topbar default title')}
                            </button>
                        )}
                    </div>
                    <div className="text-[11px] text-slate-500 mt-1">
                        {activeChat?.updatedAt || t('aura topbar just now')}
                    </div>
                </div>

                <div className="text-[11px] text-slate-600">
                    <span className="rounded-full bg-white/60 border border-white/60 px-3 py-1.5 backdrop-blur
                    shadow-[0_12px_28px_rgba(15,23,42,0.08)] inline-block">
                        {t('aura topbar customer label') + ': '}{customerDisplay}
                    </span>
                </div>
            </div>

            <div className="flex flex-wrap gap-2 mt-3">
                {chips.map((chip) => (
                    <button
                        key={chip.label}
                        type="button"
                        onClick={() => onChipClick(chip.question)}
                        className={`rounded-full px-4 py-1.5 text-[11px] font-medium
                        border border-white/70 bg-gradient-to-r ${chip.cls}
                        shadow-[0_16px_40px_rgba(99,102,241,0.18)] hover:opacity-95`}
                    >
                        {chip.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ChatTopBar;
